export default {
    'widthFix': ['height'],
    'heightFix': ['width']
};
